export default __webpack_public_path__ + "static/media/Pipes.247a778b.svg";